export const MessageConst = {
    fieldRequired: ' талбарын утга хоосон байна.',
    generalFieldRequired: 'Заавал бөглөх талбарын утга хоосон байна.',
    success: 'Амжилттай'
};

export const MessageConstEn = {
    fieldRequired: ' field is empty.',
    generalFieldRequired: 'Field is empty.',
    success: 'Success'
};